import React, { PropsWithChildren } from "react";

import { SupText } from "@repo/core-ui";
import Link from "next/link";
import UiTooltip from "@/components/Ui/Tooltip";
import { twMerge } from "tailwind-merge";

export interface GridCellsLinkProps extends PropsWithChildren {
  href: string;
  title?: string;
  limit?: number;
  target?: string;
  className?: string;
}

export default function GridCellsLink({ href, title, children, target, limit = 22, className }: GridCellsLinkProps) {
  const showTooltip = !!title && limit !== 0 && title.length > limit;
  const titleWrapped = (
    <SupText variant="body1" className="w-full overflow-hidden text-ellipsis uppercase">
      {title}
    </SupText>
  );
  return (
    <UiTooltip content={`${title}`} enable={showTooltip}>
      <Link
        className={twMerge(
          "text-neutral-900 decoration-from-font lg:hover:text-primary-600",
          "inline-flex cursor-pointer text-[16px]",
          "items-center whitespace-nowrap font-sans",
          "w-full leading-[18px]",
          target && "underline underline-offset-2 hover:no-underline",
          className
        )}
        href={href}
        target={target}
      >
        {children || titleWrapped}
      </Link>
    </UiTooltip>
  );
}
